import { IMAGE_RESIZER_URL } from '@src/config';
let webp = null;

const detectWebpSupport = () => {
    const elem = document.createElement('canvas');
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!(elem.getContext && elem.getContext('2d'))) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
};

const canUseWebp = () => {
    if (webp === null) {
        webp = detectWebpSupport();
    }
    return webp;
};

export const getPictureLink = (url = '', args = {}, alpha = false) => {
    if (!url) return null;
    if (!IMAGE_RESIZER_URL || !url.toLowerCase().startsWith('http')) {
        return url;
    }

    const isGif = url.toLowerCase().endsWith('.gif');
    let outputFormat = 'jpg';

    if (isGif) {
        outputFormat = 'gif';
    } else if (canUseWebp()) {
        outputFormat = 'webp';
    } else if (alpha) {
        outputFormat = 'png';
    }

    const params = new URLSearchParams({
        ...args,
        ...(args.w ? { w: Math.round(args.w) } : {}),
        ...(args.h ? { h: Math.round(args.h) } : {}),
        url,
        output: outputFormat,
        n: isGif ? -1 : 1, // Weserv : -1 means until the end of the document
    }).toString();

    return `${IMAGE_RESIZER_URL}/?${params}`;
};
